"use client";

import React from "react";
import { ArrowRight, Mic, Video, ChartBar, Users } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "01",
  icon: Mic,
  title: "Agendamento",
  description: "Definimos data, formato e participantes da gravação."
}, {
  number: "02",
  icon: Video,
  title: "Gravação no Estúdio",
  description: "Captação de áudio e vídeo com suporte completo da equipe."
}, {
  number: "03",
  icon: ChartBar,
  title: "Edição e Cortes",
  description: "Tratamento do material e criação de conteúdos prontos para uso."
}, {
  number: "04",
  icon: Users,
  title: "Entrega do Material",
  description: "Você recebe tudo pronto para publicar nas redes."
}];
function StepCard({
  step,
  index
}: {
  step: typeof steps[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const Icon = step.icon;
  return <div data-index={index} ref={ref} className="group" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(32px)",
    transition: `opacity 0.6s ease ${index * 0.15}s, transform 0.6s ease ${index * 0.15}s`
  }}>
      <Card className="relative overflow-hidden h-full rounded-xl py-0" style={{
      background: "hsl(0, 0%, 100%)",
      border: "1px solid hsl(0, 0%, 90%)",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05)",
      transition: "box-shadow 0.35s ease, border-color 0.35s ease, transform 0.35s ease"
    }} onMouseEnter={e => {
      const el = e.currentTarget;
      el.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
      el.style.borderColor = "hsl(270, 70%, 45%)";
    }} onMouseLeave={e => {
      const el = e.currentTarget;
      el.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.05)";
      el.style.borderColor = "hsl(0, 0%, 90%)";
    }}>
        {}
        <div className="absolute inset-0 pointer-events-none opacity-[0.02]">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id={`hex-${index}`} x="0" y="0" width="56" height="48" patternUnits="userSpaceOnUse">
                <polygon points="28,2 52,14 52,38 28,50 4,38 4,14" fill="none" stroke="hsl(270, 70%, 45%)" strokeWidth="1" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill={`url(#hex-${index})`} />
          </svg>
        </div>

        <CardContent className="relative z-10 flex flex-col gap-5 p-7">
          {}
          <div className="flex items-center gap-3">
            <span className="font-default text-xs font-bold tracking-widest uppercase" style={{
            color: "hsl(270, 70%, 45%)"
          }}>
              PASSO {step.number}
            </span>
            <div className="flex-1 h-px" style={{
            background: "hsl(270, 10%, 90%)"
          }} />
          </div>

          {}
          <div className="w-14 h-14 rounded-xl flex items-center justify-center" style={{
          background: "hsl(270, 70%, 97%)",
          border: "1px solid hsl(270, 70%, 90%)"
        }}>
            <Icon size={26} strokeWidth={1.6} style={{
            color: "hsl(270, 70%, 45%)"
          }} />
          </div>

          {}
          <h3 className="font-default text-xl font-bold leading-tight" style={{
          color: "hsl(0, 0%, 10%)"
        }}>
            {step.title}
          </h3>

          {}
          <p className="font-default text-sm leading-relaxed" style={{
          color: "hsl(0, 0%, 40%)"
        }}>
            {step.description}
          </p>

          {}
          {index < steps.length - 1 && <div className="hidden xl:flex absolute -right-5 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full items-center justify-center" style={{
          background: "hsl(0, 0%, 100%)",
          border: "1px solid hsl(0, 0%, 90%)"
        }}>
              <ArrowRight size={16} style={{
            color: "hsl(270, 70%, 45%)"
          }} />
            </div>}
        </CardContent>
      </Card>
    </div>;
}
export default function FourEasySteps() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="232270" id="howitworkstimeline" className="relative w-full py-20 md:py-28 overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.015]">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="hex-bg-steps" x="0" y="0" width="80" height="69" patternUnits="userSpaceOnUse">
              <polygon points="40,2 74,20 74,56 40,74 6,56 6,20" fill="none" stroke="hsl(270, 70%, 45%)" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hex-bg-steps)" />
        </svg>
      </div>

      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[200px] pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, hsla(270, 70%, 45%, 0.05) 0%, transparent 70%)"
    }} />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        {}
        <div ref={headingRef} className="text-center mb-14" style={{
        opacity: headingVisible ? 1 : 0,
        transform: headingVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 0.6s ease, transform 0.6s ease"
      }}>
          <div className="inline-flex items-center gap-2 mb-4 px-4 py-1.5 rounded-full" style={{
          border: "1px solid hsl(270, 70%, 90%)",
          background: "hsl(270, 70%, 98%)"
        }}>
            <span className="w-2 h-2 rounded-full" style={{
            background: "hsl(270, 70%, 45%)"
          }} />
            <span className="font-default text-xs font-bold uppercase tracking-widest" style={{
            color: "hsl(270, 70%, 45%)"
          }}>
              Processo de Produção
            </span>
          </div>

          <h2 className="font-default text-3xl sm:text-4xl lg:text-5xl font-bold mb-4" style={{
          color: "hsl(0, 0%, 10%)"
        }}>Como Funciona a Gravação do Seu Podcast</h2>
          <p className="font-default text-base sm:text-lg max-w-2xl mx-auto" style={{
          color: "hsl(0, 0%, 40%)"
        }}>Processo simples e direto para gravar seu podcast com qualidade profissional em nosso estúdio em Pinheiros.</p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 xl:gap-7">
          {steps.map((step, i) => <StepCard key={step.number} step={step} index={i} />)}
        </div>

        {}
        <div className="mt-12 text-center" style={{
        opacity: headingVisible ? 1 : 0,
        transition: "opacity 0.8s ease 0.7s"
      }}>
          <p className="font-default text-sm text-muted-foreground" style={{
          color: "hsl(0, 0%, 40%)"
        }}>Você foca no conteúdo, a ITC+ cuida de toda a produção.</p>
        </div>
      </div>
    </section>;
}